import { useState } from 'react';

export default function useCarousel(initial, length) {
  const [current, setCurrent] = useState(initial);

  const handleNext = () => {
    if (current === length) {
      setCurrent(0);

      return;
    }

    setCurrent(current + 1);
  };

  const handlePrev = () => {
    if (current === 0) {
      setCurrent(length);

      return;
    }

    setCurrent(current - 1);
  };

  return [current, handleNext, handlePrev, setCurrent];
}



// WEBPACK FOOTER //
// ./src/components/helpers/hooks/useCarousel.js